import { h, Component } from 'preact'
import { connect } from 'unistore/preact'
import { dateFormatLocalized } from '../helpers/dateHelpers'

const FormattedDate = connect('config')(
    class extends Component {
        constructor() {
            super()
            this.state = { formattedDate: '' }
        }

        componentWillMount() {
            dateFormatLocalized(this.props.date, this.props.format, this.props.config.culture)
                .then((date) => this.setState({ formattedDate: date }))
        }

        componentWillReceiveProps(nextProps) {
            if (nextProps.date !== this.props.date
                || nextProps.format !== this.props.format
                || nextProps.config.culture !== this.props.config.culture) {
                dateFormatLocalized(nextProps.date, nextProps.format, nextProps.config.culture)
                    .then((date) => this.setState({ formattedDate: date }))
            }
        }
    
        render({}, { formattedDate }) {
            return <span>{ formattedDate }</span>
        }
    }
)

export default FormattedDate